import { render, staticRenderFns } from "./CMateriales.vue?vue&type=template&id=bcb916e0&"
import script from "./CMateriales.vue?vue&type=script&lang=js&"
export * from "./CMateriales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports